import { BaseComponent } from '@/mainComponent/items/BaseComponent';
import { getSpinView } from '@/mainComponent/items/gameUIControllers/data';
import { BetController } from "@/mainComponent/items/gameUIControllers/BetController";

class SpinController extends BaseComponent {
  private _isInitialization: boolean = false;
  private uiContainer: any;
  constructor() {
    super();
    this.setHandlers();
    this.setView();
    this.update();
  }

  setHandlers(): void {
    game.on('STORE.BET_CHANGED', () => {
      this.update();
      BetController.prototype.updateBets();
    });
  }

  setView(): void {
    this.uiContainer = game.tree.findByName('ui.wrapper_container');
    this.getViewConfig().forEach((item: any) => this.uiContainer.addChild(game.builder.create(item)));
    this._isInitialization = true;
  }

  update(): void {
    this.uiContainer.children.forEach((children: any) => {
      switch (children.name) {
        case 'ui.spin_btn.bonus_game':
          children.options.visible = this.isAchievementBGProgress;
          break;
        case 'ui.spin_btn.free_spins_game':
          children.options.visible = this.isAchievementFSProgress;
          break;
        case 'ui.spin_btn.free_rounds':
          children.options.visible = this.isAchievementProgress;
          break;
        case 'ui.spin_btn.tournament_label':
          children.options.visible = this.isTournamentProgress;
          break;
      }
    });
    game.component.ui.onChangeOrientation();
  }

  getViewConfig(): any[] {
    const isTurboSpin =
      game.component.promo.options.config?.settings?.isTurboSpin !== undefined
        ? game.component.promo.options.config?.settings?.isTurboSpin
        : true;
    return getSpinView(isTurboSpin);
  }

  get isAchievementProgress(): boolean {
    return (
      this.store.promo.isProgressGameAchievement() &&
      this.store.promo.isBetProperly(this.store.gameData.bet) &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      !this.store.promo.isFreeSpinsGame()
    );
  }

  get isAchievementBGProgress(): boolean {
    return (
      this.store.promo.isProgressGameAchievementBG() &&
      this.store.promo.isBetProperly(this.store.gameData.bet) &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      !this.store.promo.isFreeSpinsGame()
    );
  }
  get isAchievementFSProgress(): boolean {
    return (
      this.store.promo.isProgressGameAchievementFS() &&
      this.store.promo.isBetProperly(this.store.gameData.bet) &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      !this.store.promo.isFreeSpinsGame()
    );
  }

  get isTournamentProgress(): boolean {
    return (
      this.store.promo.isProgressTournament() &&
      this.store.promo.isBetProperly(this.store.gameData.bet) &&
      !this.store.gameData.freeSpinsGame.isPlaying() &&
      !this.store.gameData.bonusGame.isPlaying() &&
      !this.store.promo.isFreeSpinsGame()
    );
  }
}

export { SpinController };
